import { Application, Controller } from "stimulus"

const cardViewTimeTnterval = 2000

export default class ViewTourController extends Controller {

  static targets = [ "card" ]

  connect() {

    // console.log('Conecting')
    var tourIsPreviouslyViewed = this.tourIsPreviouslyViewed
    var addIdToTourToursViewedCookie = this.addIdToTourToursViewedCookie

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        let id = entry.target.getAttribute("data-view-tour-id-value");
        let reference = entry.target.getAttribute("data-view-reference-value");
        let position = entry.target.getAttribute("data-view-position-value");
        let filters = entry.target.getAttribute("data-view-filters-value");
        
        if (tourIsPreviouslyViewed(id)) {
          observer.unobserve(entry.target)
          return
        }
        if(entry.isIntersecting) {
          if (entry.intersectionRatio == 1) {
            entry.target.dataset.lastViewedTime = entry.time
            var intervalId = window.setInterval(function(card, tourId, reference, position, filters) {
              let currentTime = performance.now()
              let cardLastViewedTime = card.dataset.lastViewedTime
              if (cardLastViewedTime > 0 && currentTime - cardLastViewedTime > cardViewTimeTnterval) {
                // console.log("CALLING " + tourId + ", "+ reference+ ", "+ position)

                setTimeout(() => {
                  Rails.ajax({
                    url: "/tracking/tour_card_views",
                    data: ["tour_id=", tourId, "&position=", position, "&reference=", reference, "&filters=", filters].join(''),
                    type: "post"
                  })
                }, 2000);

                addIdToTourToursViewedCookie(tourId)
                clearInterval(intervalId)
                observer.unobserve(card);
              } else {
                clearInterval(intervalId)
              }
            }, cardViewTimeTnterval, entry.target, id, reference, position, filters);
          } else {
            entry.target.dataset.lastViewedTime = 0  
          }
        } else {
          entry.target.dataset.lastViewedTime = 0
        }
    });
    }, { threshold: [0, 1] });

    observer.observe(this.element);
  }

  tourIsPreviouslyViewed(id) {
    var toursViewed = sessionStorage.getItem("tours_viewed")
    let isViewed = false
    if (toursViewed) {
      var tourIds = sessionStorage.getItem("tours_viewed").split("|")
      isViewed = tourIds.includes(id)
    }
    return isViewed
  }

  addIdToTourToursViewedCookie(id) {
    let currentValue = sessionStorage.getItem("tours_viewed")

    if (currentValue) {
      currentValue = currentValue.concat("|", id);
    } else {
      currentValue = "|".concat(id);
    }
    currentValue = sessionStorage.setItem("tours_viewed", currentValue)
  }

  async trackTourClick(e) {
    const tour_id = this.cardTarget.dataset.viewTourIdValue;
    const filters = this.cardTarget.dataset.viewFiltersValue;
    const reference = this.cardTarget.dataset.viewReferenceValue;
    const position = this.cardTarget.dataset.viewPositionValue;
    const locale = this.cardTarget.dataset.viewLocaleValue;

    const track_params = { tour_id: parseInt(tour_id),
                         position: parseInt(position),
                         reference: reference,
                         filters: JSON.parse(filters) };
      
    var track_date = {};
    if (e.target.closest('[data-controller=fake-link]')) {
      track_date = {date: e.target.closest('[data-controller=fake-link]').dataset.date}
    }
  
    fetch("/tracking/tour_clicks", { method: 'post',
                                     body: JSON.stringify({...track_params, ...track_date}),
                                     headers: { 'Content-Type': 'application/json',
                                                'X-CSRF-Token': Rails.csrfToken()
                                              },
                                     credentials: 'same-origin'
                                   });

    const tourContent = document.querySelector(`[data-tour-id='${tour_id}']`);
    var event_data = { item_list_name: "Place",
                       item_list_id: tourContent.dataset.placeName,
                       items: [
                               { id: tour_id,
                                 name: tourContent.querySelector(".place-tour-title").innerText,
                                 brand: tourContent.dataset.guru,
                                 category: tourContent.dataset.placeName,
                                 variant: locale,
                                 price: tourContent.dataset.price
                               }
                              ]
                     }
    gtag("event", "select_item", event_data);
  }
}

const application = Application.start()
application.register("view-tour", ViewTourController)
